import { useEffect, useRef } from 'react';

/**
 * Runs `onRestored` when the browser shows this page again from its
 * back/forward cache, e.g. Back from Stripe Checkout. The page comes back
 * exactly as it was left, so a button that spun while redirecting is still
 * spinning; this is where to reset it.
 */
export function usePageRestored(onRestored: () => void) {
  const callback = useRef(onRestored);
  callback.current = onRestored;

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) callback.current();
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);
}
